import { render, staticRenderFns } from "./truckSoil.vue?vue&type=template&id=3b7d0dd9&scoped=true"
import script from "./truckSoil.vue?vue&type=script&lang=js"
export * from "./truckSoil.vue?vue&type=script&lang=js"
import style0 from "./truckSoil.vue?vue&type=style&index=0&id=3b7d0dd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7d0dd9",
  null
  
)

export default component.exports